import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

function App() {
  const [logs, setLogs] = useState([]);
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [search, setSearch] = useState('');
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);

  // Ophalen logs & stats
  useEffect(() => {
    if (!token) return;
    const fetchLogs = () => {
      fetch('/api/logs', {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => {
          if (!res.ok) throw new Error('Kan logs niet ophalen');
          return res.json();
        })
        .then(data => setLogs(data))
        .catch(() => setLogs([]));

      fetch('/api/stats/daily', {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => {
          if (!res.ok) throw new Error('Kan stats niet ophalen');
          return res.json();
        })
        .then(data => setStats(data))
        .catch(() => setStats([]));
    };

    fetchLogs();
    const interval = setInterval(fetchLogs, 15000);
    return () => clearInterval(interval);
  }, [token]);

  // Login handler
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      if (!res.ok) {
        let msg = 'Inloggen mislukt';
        try { msg = (await res.json()).error || msg; } catch {}
        throw new Error(msg);
      }
      const data = await res.json();
      if (data.token) {
        setToken(data.token);
        localStorage.setItem('token', data.token);
      } else {
        throw new Error('Token ontbreekt');
      }
    } catch (err) {
      alert('Login fout: ' + err.message);
    }
    setLoading(false);
  };

  // Logout handler
  const handleLogout = () => {
    setToken('');
    setLogs([]);
    setStats([]);
    localStorage.removeItem('token');
    setUsername('');
    setPassword('');
  };

  // UI bij niet ingelogd
  if (!token) {
    return (
      <div style={{
        padding: '2rem', maxWidth: 400, margin: '50px auto', background: '#fff',
        borderRadius: 8, boxShadow: '0 0 10px #eee'
      }}>
        <h2 style={{ marginBottom: 20 }}>Login Dashboard</h2>
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Gebruikersnaam"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={{ width: '100%', padding: 8, marginBottom: 10 }}
            autoFocus
            disabled={loading}
          />
          <input
            type="password"
            placeholder="Wachtwoord"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ width: '100%', padding: 8, marginBottom: 16 }}
            disabled={loading}
            onKeyDown={e => e.key === 'Enter' && handleLogin(e)}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: 10,
              background: '#6366f1',
              color: 'white',
              border: 'none',
              borderRadius: 4,
              fontWeight: 'bold'
            }}>
            {loading ? 'Inloggen...' : 'Inloggen'}
          </button>
        </form>
      </div>
    );
  }

  // Filter logs op zoekveld
  const filteredLogs = logs.filter(log =>
    (log.message || '').toLowerCase().includes(search.toLowerCase()) ||
    (log.response || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
        <h1>WhatsApp Logs Dashboard</h1>
        <button
          onClick={handleLogout}
          style={{
            background: '#ef4444', color: 'white', border: 'none', borderRadius: 4,
            padding: '0.5rem 1.2rem', fontWeight: 'bold'
          }}>
          Uitloggen
        </button>
      </div>
      <input
        type="text"
        placeholder="Zoek in berichten of antwoorden..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ padding: '0.5rem', marginBottom: '1rem', width: '100%' }}
      />
      <h2>Berichten per dag</h2>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={stats}>
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="count" fill="#6366f1" />
        </BarChart>
      </ResponsiveContainer>
      <h2>Laatste berichten</h2>
      <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
        {filteredLogs.map(log => (
          <li key={log.id} style={{
            marginBottom: '1rem', padding: '1rem', background: '#f9fafb', borderRadius: 6
          }}>
            <strong>{log.from_number}</strong>: {log.message} <br />
            <small style={{ color: '#666' }}>Antwoord: {log.response}</small> <br />
            <em>{new Date(log.created_at).toLocaleString()}</em>
          </li>
        ))}
        {filteredLogs.length === 0 && <li>Geen berichten gevonden.</li>}
      </ul>
    </div>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
